import { Record } from 'immutable';
import { BODY_FIGURE_TEXTS, HAIR_TYPE_TEXTS, HAIR_COLOR_TEXTS, EYELID_TEXTS } from '../consts';

export type ApiDonorPhysicalInfo = {
  blood_type: string;
  blood_rh: string;
  height: number;
  weight: number;
  body_figure: string;
  hair_type: string;
  hair_color: string;
  eyelid: string;
};

const DonorPhysicalInfoBase = Record({
  bloodType: "",
  bloodRh: "",
  height: 0,
  weight: 0,
  bodyFigure: "",
  hairType: "",
  hairColor: "",
  eyelid: "",
});

export class DonorPhysicalInfo extends DonorPhysicalInfoBase {
  constructor(apiDonorPhysicalInfo?: ApiDonorPhysicalInfo) {
    super({
      bloodType: apiDonorPhysicalInfo?.blood_type,
      bloodRh: apiDonorPhysicalInfo?.blood_rh,
      height: apiDonorPhysicalInfo?.height,
      weight: apiDonorPhysicalInfo?.weight,
      bodyFigure: apiDonorPhysicalInfo?.body_figure,
      hairType: apiDonorPhysicalInfo?.hair_type,
      hairColor: apiDonorPhysicalInfo?.hair_color,
      eyelid: apiDonorPhysicalInfo?.eyelid,
    })
  }

  readonly bodyFigureText: string = BODY_FIGURE_TEXTS[this.bodyFigure];

  readonly hairTypeText: string = HAIR_TYPE_TEXTS[this.hairType];

  readonly hairColorText: string = HAIR_COLOR_TEXTS[this.hairColor];

  readonly eyelidText: string = EYELID_TEXTS[this.eyelid];
}
